import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';

// TYPES
import { TitleFull as Title } from '@warehouse/title/core';

// LIBRARIES
import CountriesOfOriginField from '../fields/CountriesOfOrigin';
import ReleaseDate from '../fields/ReleaseDate';
import OriginalLanguagesField from '../fields/OriginalLanguages';
import RunLengthField from '../fields/RunLength';
import SortTitleField from '../fields/SortTitle';
import HouseSequenceField from '../fields/HouseSequence';
import DistributionNumberField from '../fields/DistributionNumber';

// STYLES
import { Row } from './styles';

interface EpisodeProps {
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	trigger: UseFormTrigger<any>;
	errors: FieldErrors<any>;
	dryRanTitle?: Title | undefined;
}

function Episode({ control, errors, setValue, trigger, dryRanTitle }: EpisodeProps) {
	return (
		<div>
			<Row>
				<CountriesOfOriginField
					control={control}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					isRequired
					dryRanTitle={dryRanTitle}
				/>
				<ReleaseDate
					control={control}
					isRequired
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					dryRanTitle={dryRanTitle}
				/>
			</Row>
			<Row>
				<SortTitleField
					control={control}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					dryRanTitle={dryRanTitle}
				/>
				<RunLengthField
					control={control}
					setValue={setValue}
					dryRanTitle={dryRanTitle}
					trigger={trigger}
					errors={errors}
				/>
			</Row>
			<Row>
				<HouseSequenceField
					control={control}
					dryRanTitle={dryRanTitle}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
				/>
				<DistributionNumberField
					control={control}
					dryRanTitle={dryRanTitle}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
				/>
			</Row>
			<OriginalLanguagesField
				control={control}
				setValue={setValue}
				dryRanTitle={dryRanTitle}
				trigger={trigger}
				isRequired
				errors={errors}
			/>
		</div>
	);
}

export default Episode;
